export function Steps() {
  return (
    <section className="sec">
      <div className="section-head">
        <div className="eyebrow"><span className="dot" /> How Voy works</div>
        <h2>
          Travel without the <em>tax</em>.
        </h2>
        <p>Four steps replace the endless OTA funnel. One language, yours, in; a fully priced trip out.</p>
      </div>
      <div className="steps">
        <div className="step">
          <div className="step-num">STEP 01</div>
          <h4>Tell Voy</h4>
          <p>Speak in plain English. "One-way to Tokyo, July 15, under $900."</p>
        </div>
        <div className="step">
          <div className="step-num">STEP 02</div>
          <h4>We hit raw supply</h4>
          <p>Flights and hotels straight from supplier APIs. No markup on top.</p>
        </div>
        <div className="step">
          <div className="step-num">STEP 03</div>
          <h4>See real prices</h4>
          <p>The supplier&apos;s price. No markup.</p>
        </div>
        <div className="step">
          <div className="step-num">STEP 04</div>
          <h4>Book &amp; go</h4>
          <p>Check out securely with Stripe.</p>
        </div>
      </div>
    </section>
  );
}
